export default "__VITE_ASSET__Bn6xO9qd__"